import React from "react";
import {useRecoilState, useResetRecoilState} from "recoil";
import Slider from "@mui/material/Slider";
import {useForm, Controller} from "react-hook-form";

import {MultiSelect} from "components/form";
import Input from "components/input-fields/input-fields";
import {AppsFilterAtom} from "../browse-apps.service";
import Down from "assets/images/svg/dropdown_blue.svg";
import {useQuery} from "react-query";
import {client} from "helpers/client";
import {useTranslation} from "react-i18next";
import {useToggle} from "react-use";
import {css} from "@emotion/css";

const priceStep = 100;

export default function AppFilters() {
    const {t} = useTranslation("browse-apps");
    const [showSubType, toggleSubType] = useToggle(false);
    const resetList = useResetRecoilState(AppsFilterAtom);
    const [showModules, toggleShowModules] = useToggle(false);
    const [filters, setFilters] = useRecoilState(AppsFilterAtom);

    const {register, handleSubmit, reset, control, watch, setValue} = useForm({
        defaultValues: filters,
    });

    const {data: serverPriceRange, isSuccess} = useQuery(
        "price-range",
        () => client<any>("/apps/getPriceRange").then((re) => re.response),
        {
            onSuccess(response) {
                // setFilters({
                //   ...filters,
                //   priceRange: [response?.priceFrom, response?.priceTo],
                // });
                reset({
                    ...filters,
                    priceRange: [response?.priceFrom, response?.priceTo],
                });
            },
        }
    );

    const {data: Modules = []} = useQuery("modules", () =>
        client<any[]>("/lookup/modules/getAll").then((r) => r.response ?? [])
    );

    const priceRange = watch("priceRange");

    const handlePriceRangeChange = (
        e: Event,
        newValue: number[] | number,
        activeThumb: number
    ) => {
        if (!Array.isArray(newValue)) return;

        if (activeThumb === 0) {
            setValue("priceRange", [
                Math.min(newValue[0], priceRange[1] - priceStep),
                priceRange[1],
            ]);
        } else {
            setValue("priceRange", [
                priceRange[0],
                Math.max(newValue[1], priceRange[0] + priceStep),
            ]);
        }
    };

    const clearFilters = () => {
        reset();
        resetList();
    };

    return (
        <form
            className="filter"
            onSubmit={handleSubmit((data) => setFilters(data))}
        >
            <div className="header">
                <h1 className="filter-title">{t("filterBox.filterLabel") as string}</h1>
                <span className="clear" onClick={() => clearFilters()}>
          {t("filterBox.clearFilter") as string}
        </span>
            </div>

            <div className="tabs">
                <div className="tab" id="one">
                    <h3 className="tabTitle active">
                        {t("filterBox.subscriptionType") as string}
                        <img
                            src={Down}
                            className={
                                !showSubType
                                    ? ""
                                    : css`
                                          transform: rotateZ(180deg);
                                    `
                            }
                            alt="Down"
                            onClick={toggleSubType}
                        />
                    </h3>
                </div>

                <div className="content collapsee" hidden={!showSubType} id="content-one">
                    <Input
                        type="radio"
                        label={t("filterBox.all")}
                        value="0"
                        {...register("subscriptionType")}
                    />
                    <Input
                        type="radio"
                        label={t("filterBox.forever")}
                        value="1"
                        {...register("subscriptionType")}
                    />
                    <Input
                        type="radio"
                        label={t("filterBox.monthlyYearly")}
                        value="2"
                        {...register("subscriptionType")}
                    />
                </div>

                <div className="tab" id="tow">
                    <h3 className="tabTitle">
                        {t("filterBox.modules") as string}
                        <img
                            src={Down}
                            className={
                                !showModules
                                    ? ""
                                    : css`
                                          transform: rotateZ(180deg);
                                    `
                            }
                            alt="Down"
                            onClick={toggleShowModules}
                        />
                    </h3>
                </div>

                <div className="content" hidden={!showModules} id="content-tow">
                    <Controller
                        render={({field}) => (
                            <MultiSelect field={field} options={Modules}/>
                        )}
                        name="modules"
                        control={control}
                    />
                </div>

                <div className="tab" id="tow">
                    <h3 className="tabTitle"> {t("filterBox.priceRangeFilter") as string}</h3>
                </div>
                <div className="content " id="content-tow">
                    <div className="row">
                        <div className="col-12">
                            <Input
                                type="number"
                                step='0.000000001'
                                label={t("filterBox.from")}
                                value={priceRange[0]}
                                onChange={({target}) =>
                                    setValue("priceRange", [+target.value, priceRange[1]])
                                }
                            />
                        </div>
                        <div className="col-12">
                            <Input
                                type="number"
                                step='0.000000001'
                                label={t("filterBox.to")}
                                value={priceRange[1]}
                                onChange={({target}) =>
                                    setValue("priceRange", [priceRange[0], +target.value])
                                }
                            />
                        </div>
                    </div>
                    <div className='mx-3'>
                        {isSuccess && (
                            <Controller
                                render={({field}) => (
                                    <Slider
                                        min={serverPriceRange?.priceFrom}
                                        max={serverPriceRange?.priceTo}
                                        ref={field.ref}
                                        value={field.value}
                                        onChange={handlePriceRangeChange}
                                    />
                                )}
                                name="priceRange"
                                control={control}
                            />
                        )}
                    </div>
                </div>
            </div>

            <button type="submit" className="btn-White">
                {t("filterBox.Apply") as string}
            </button>
        </form>
    );
}
